import React, { FC, Fragment } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames } from "../../clients/FirebaseClient/types";

const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        formControlLabelCheckboxStyle: {
            width: 300,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const ModificationPersonalContributionUndergroundWorkForm: FC = () => {
    const classes = useStyles();

    const { values, setValues } = useFormModel<
        ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK
    >();

    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <FormControlLabel
                isCheckBox={true}
                className={formControlClasses.formControlLabelCheckboxStyle}
                control={
                    <Checkbox
                        className={formControlClasses.checkboxStyle}
                        value="PersonalContributionCanDoUndergroundWork"
                        checked={
                            values.modificationPersonalContributionCanDoUndergroundWork.value.yes
                        }
                        onChange={(event, checked) =>
                            setValues(values => {
                                if (checked) {
                                    values.modificationPersonalContributionCanDoUndergroundWork.value.yes = true;
                                    values.modificationPersonalContributionCanDoUndergroundWork.value.no = false;
                                } else {
                                    values.modificationPersonalContributionCanDoUndergroundWork.value.yes = false;
                                    values.modificationPersonalContributionCanDoUndergroundWork.value.no = true;
                                }
                            })
                        }
                    />
                }
                label="Tiefbau"
                error={values.modificationPersonalContributionCanDoUndergroundWork.error !== null}
            />
            <p
                className={classes.pSmall}
                style={{ marginTop: 10, marginBottom: 15, marginLeft: 44 }}
            >
                Der Graben ab Kundengrundstück bis zur Gebäudeeinführung kann in Eigenleistung
                ausgeführt werden.
            </p>
        </Fragment>
    );
};
